@if (tenantSelectionne(); as tenant) {
  <div class="header">
    <h4>Informations du client</h4>
    @if (chargementDetailEnCours()) {
      <app-spinner size="lg" ariaLabel="Chargement du client" />
    }
    @if (detailClient()?.possedeFicheAnnuaire && accesComplet()) {
      <button
        type="button"
        appButton
        variant="outline"
        icon="refresh"
        appTooltip="Synchronise les options et la connection string entre l'annuaire legacy et la configuration Azure (le sens vous sera demandé)"
        (click)="resynchroniser()"
      >
        Synchroniser ce client
      </button>
    }
  </div>
  <form [formGroup]="clientForm" class="formulaire_client" (ngSubmit)="valider()">
    <div class="info_client">
      <p class="libelle_info">Identifiant</p>
      <p>{{ tenant.identifier }}</p>
      @if (detailClient()?.actifSurBackstage) {
        <img
          class="badge_backstage"
          [src]="'assets/img/T&LB_logo_colored.svg'"
          alt="Actif sur BackStage"
          appTooltip="Encaissement Tick&Live Actif"
        />
      }
    </div>

    <div class="ligne_label_base">
      <div class="champ_avec_desync">
        <app-form-field label="Label">
          <app-input formControlName="label" [maxLength]="longueurs.label" />
        </app-form-field>
        @if (desynchronisation('label'); as desync) {
          <app-icon
            name="warning"
            class="icone_desync"
            [appTooltip]="'Valeur annuaire : ' + (desync.valeurAnnuaire || '(vide)')"
          />
          @if (accesComplet()) {
            <button
              type="button"
              appButton
              variant="ghost"
              iconOnly
              icon="refresh"
              label="Reprendre la valeur de l'annuaire"
              appTooltip="Reprendre la valeur de l'annuaire"
              (click)="appliquerValeurAnnuaire('label')"
            ></button>
          }
        }
      </div>

      <div class="bloc_base_de_donnees">
        <!-- Enveloppé dans `app-form-field` pour que le libellé s'affiche AU-DESSUS
             du champ, comme celui de « Label » à côté : en mode `field`, le `label`
             d'`app-select` ne sert que de texte d'état vide à l'intérieur du champ.
             `SelectComponent` fournit `FIELD_CONTROL`, donc le câblage aria suit.
             `app-select` n'implémente pas ControlValueAccessor : le contrôle est
             piloté explicitement (voir PROVENANCE.md, écarts connus). -->
        <app-form-field label="Base de données" class="champ_database">
          <app-select
            label="Sélectionner une base"
            trigger="field"
            [clearable]="true"
            selectionMode="single"
            [fullWidth]="true"
            [options]="optionsBases()"
            [selected]="basesSelectionnees()"
            (selectionChange)="choisirBaseDeDonnees($event)"
          />
        </app-form-field>

        @if (accesComplet()) {
          <div class="action_connection_string">
            <button
              type="button"
              appButton
              variant="outline"
              [disabled]="!valeursClient().databaseName || chargementConnectionStringEnCours()"
              (click)="modifierBaseDeDonnees()"
            >
              Modifier la connection string
            </button>
            @if (chargementConnectionStringEnCours()) {
              <app-spinner size="lg" ariaLabel="Chargement de la connection string" />
            }
          </div>
        }
      </div>
    </div>

    <hr class="separateur_section" />
    <p class="titre_section">Options</p>
    <div class="ligne_toggles">
      <app-toggle
        label="Manager"
        [checked]="!!valeursClient().managerIsEnabled"
        (checkedChange)="clientForm.controls.managerIsEnabled.setValue($event)"
      />

      <div class="option_avec_desync">
        <app-toggle
          label="Désactivé"
          [checked]="!!valeursClient().disabled"
          (checkedChange)="clientForm.controls.disabled.setValue($event)"
        />
        @if (desynchronisation('disabled'); as desync) {
          <app-icon
            name="warning"
            class="icone_desync"
            [appTooltip]="'Valeur annuaire : ' + (desync.valeurAnnuaire === 'true' ? 'activé' : 'désactivé')"
          />
          <button
            type="button"
            appButton
            variant="ghost"
            iconOnly
            icon="refresh"
            label="Reprendre la valeur de l'annuaire"
            appTooltip="Reprendre la valeur de l'annuaire"
            (click)="appliquerValeurAnnuaire('disabled')"
          ></button>
        }
      </div>

      <div class="option_avec_desync">
        <app-toggle
          label="Archivage actif"
          [checked]="!!valeursClient().isActiveArchiving"
          (checkedChange)="clientForm.controls.isActiveArchiving.setValue($event)"
        />
        @if (desynchronisation('isActiveArchiving'); as desync) {
          <app-icon
            name="warning"
            class="icone_desync"
            [appTooltip]="'Valeur annuaire : ' + (desync.valeurAnnuaire === 'true' ? 'activé' : 'désactivé')"
          />
          <button
            type="button"
            appButton
            variant="ghost"
            iconOnly
            icon="refresh"
            label="Reprendre la valeur de l'annuaire"
            appTooltip="Reprendre la valeur de l'annuaire"
            (click)="appliquerValeurAnnuaire('isActiveArchiving')"
          ></button>
        }
      </div>
    </div>

    <!-- Meetch sur sa propre ligne : la zone de saisie de la clé s'aligne sur le toggle -->
    <div class="ligne_meetch">
      <app-toggle
        label="Meetch"
        [checked]="!!valeursClient().meetchIsEnabled"
        (checkedChange)="clientForm.controls.meetchIsEnabled.setValue($event)"
      />
      @if (valeursClient().meetchIsEnabled) {
        <div class="champ_avec_desync champ_meetch">
          <!-- Écriture seule : la clé enregistrée n'est jamais renvoyée par le backend, on
               n'en indique que la présence. Laisser vide conserve la clé actuelle -->
          <app-form-field label="Clé API Meetch">
            <app-input
              type="password"
              revealable
              autocomplete="new-password"
              formControlName="meetchApiKey"
              [maxLength]="longueurs.secret"
              [placeholder]="cleMeetchEnregistree() ? 'Clé enregistrée — saisir pour remplacer' : 'Aucune clé'"
            />
          </app-form-field>
          @if (desynchronisation('meetchApiKey')) {
            <app-icon
              name="warning"
              class="icone_desync"
              appTooltip="La clé du client diffère de celle de l'annuaire. Sa valeur n'est pas affichée : utiliser « Resynchroniser » pour reprendre celle de l'annuaire"
            />
          }
        </div>
      }
    </div>

    <hr class="separateur_section" />
    <div class="entete_fils_de_leau">
      <p class="titre_section">Fils de l'eau</p>
      <button
        type="button"
        appButton
        variant="outline"
        icon="search"
        [disabled]="chargementFilsDeLEauEnCours() || reprovisionnementEnCours()"
        appTooltip="Vérifie sur la base Aparté du client la présence des objets attendus par les fils de l'eau (tables tampon, procédures, triggers)"
        (click)="verifierFilsDeLEau()"
      >
        Vérifier le provisionnement
      </button>
      <!-- Pas de garde accesComplet() : les fils de l'eau sont dans le périmètre de
           ServiceClient, qui doit pouvoir corriger la divergence qu'on lui montre -->
      @if (divergenceFilsDeLEau()) {
        <button
          type="button"
          appButton
          variant="primary"
          icon="refresh"
          [disabled]="reprovisionnementEnCours() || chargementFilsDeLEauEnCours()"
          appTooltip="Rejoue les scripts de provisionnement sur la base Aparté du client pour les fils de l'eau déjà activés. Rejouable et sans suppression : seuls les objets manquants sont posés, procédures et triggers sont réalignés"
          (click)="reprovisionnerFilsDeLEau()"
        >
          Reprovisionner
        </button>
      }
      @if (chargementFilsDeLEauEnCours() || reprovisionnementEnCours()) {
        <app-spinner
          size="lg"
          [ariaLabel]="
            reprovisionnementEnCours()
              ? 'Reprovisionnement des fils de l\'eau'
              : 'Vérification du provisionnement des fils de l\'eau'
          "
        />
      }
    </div>
    <div class="ligne_toggles">
      <app-toggle
        label="Orange"
        [checked]="!!valeursClient().isOrange"
        (checkedChange)="clientForm.controls.isOrange.setValue($event)"
      />
      <app-toggle
        label="Skidata"
        [checked]="!!valeursClient().isSkidata"
        (checkedChange)="clientForm.controls.isSkidata.setValue($event)"
      />
      <app-toggle
        label="Eventim"
        [checked]="!!valeursClient().isEventim"
        (checkedChange)="clientForm.controls.isEventim.setValue($event)"
      />
    </div>
    @if (etatFilsDeLEau(); as etat) {
      @if (!etat.prerequisSatisfaits) {
        <app-alert variant="error">
          Les colonnes de rattachement du schéma Aparté sont absentes de la base {{ etat.baseDeDonnees }} : aucun script
          de fil de l'eau ne les crée, l'anomalie demande un DBA.
        </app-alert>
      } @else {
        <div class="etat_fils_de_leau">
          <span
            [appTooltip]="
              etat.socleProvisionne
                ? 'Objets communs aux trois fils de l\'eau présents sur ' + etat.baseDeDonnees
                : 'Des objets du socle commun manquent sur ' +
                  etat.baseDeDonnees +
                  ' : activer un fil de l\'eau les reposera'
            "
          >
            <app-status-chip
              [tone]="etat.socleProvisionne ? 'success' : 'warning'"
              [label]="etat.socleProvisionne ? 'Socle : provisionné' : 'Socle : incomplet'"
            />
          </span>
          @for (partenaire of etat.partenaires; track partenaire.partenaire) {
            <span [appTooltip]="infobulleFilDeLEau(partenaire)">
              <app-status-chip [tone]="toneFilDeLEau(partenaire)" [label]="libelleFilDeLEau(partenaire)" />
            </span>
          }
        </div>
      }
    }
  </form>

  <div class="btnGroupe">
    <button type="button" appButton variant="primary" [disabled]="validationIndisponible()" (click)="valider()">
      Valider
    </button>
  </div>
}
